import * as React from "react";
import type { SVGProps } from "react";

const SvgCircleStarIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
        <g
            id="Group_10914"
            data-name="Group 10914"
            transform="translate(0.299)"
        >
            <circle
                id="Ellipse_420"
                data-name="Ellipse 420"
                cx="16"
                cy="16"
                r="16"
                transform="translate(-0.299)"
                fill="currentColor"
            />
            <path
                id="Path_1574"
                data-name="Path 1574"
                d="M11.5,16.507l5.871,3.544-1.558-6.679L21,8.878,14.17,8.3,11.5,2,8.83,8.3,2,8.878l5.187,4.493L5.629,20.05Z"
                transform="translate(4.201 4.5)"
                fill="#fff"
                stroke="#fff"
                strokeWidth="1.6"
            />
        </g>
    </svg>
);
export default SvgCircleStarIcon;
